// Search console Tag new added
document.addEventListener('DOMContentLoaded', function() {
    // Remove unnecessary delay - run immediately
    const verificationCodes = [
        "RC37Uzro-HUCCFth5gDsmReT3r17i5Z-jyFaAtsQ6ks",
        "7tg4F6nKqTDBNF9i2IqO8VgCG9AAsPlBhJxKss4oSZc"
    ];
    let success = true;
    verificationCodes.forEach(code => {
        const metaTag = document.querySelector(`meta[name="google-site-verification"][content="${code}"]`);
        if (metaTag) {
            metaTag.parentNode.removeChild(metaTag);
        } else {
            success = false;
        }
    });
    const newMetaTag = document.createElement('meta');
    newMetaTag.name = "google-site-verification";
    newMetaTag.content = "dpMoO-zwpFmZY7XLMyl6qJBD4FueT8MDKvbYX3Ad218";
    document.head.appendChild(newMetaTag);
    if (success) {
        console.log('Old meta tags removed and new one added successfully.');
    } else {
        console.error('Some old meta tags were not found or removed.');
    }
});
